import styled from 'styled-components';
import Logo from '../../assets/logo.png';

const blue = '#0C5BA3';
const darkblue = '#003876';

const Container = styled.main`
  height: 100%;
  width: 100%;
`;

const ListItemContainer = styled.div`
  height: 65px;
  width: 80%;
  padding: 5px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;

  &:hover {
    cursor: pointer;
    background-color: #f6f7f9;
  }

  @media (min-width: 685px) {
    width: 90%;
  }

  @media (min-width: 890px) {
    width: 45%;
    margin-right: auto;
  }
`;

const PageContent = styled.section`
  margin-left: 30px;
  margin-top: 25px;
  margin-bottom: 75px;
  overflow-y: scroll;
  display: flex;
  height: calc(100% - 75px);
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 890px) {
    justify-content: flex-start;
    align-content: flex-start;
  }
`;

const PlayerBar = styled.section`
  position: absolute;
  z-index: 3;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${blue};
  color: #e1e1e1;
  height: 75px;
  transition: all ease-in 400ms;
  margin-bottom: -5px;

  &.goUp {
    animation: 300ms linear normal moveUp;
  }

  &.stayDown {
    transform: translateY(100%);
    display: none;
  }

  @keyframes moveUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0%);
    }
  }
`;

const PlayerContentContainer = styled.div`
  padding: 10px 20px;
`;

const SideBar = styled.nav`
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  height: calc(100% + 10px);
  width: 200px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(
    180deg,
    hsla(212, 100%, 23%, 1) 0%,
    hsla(208, 87%, 34%, 1) 92%
  );
`;

const Content = styled.div`
  position: absolute;
  z-index: 2;
  height: calc(100% - 75px);
  width: calc(100% - 200px);
  top: 0;
  right: 0;
`;

const Navbar = styled.nav`
  height: 70px;
  top: 0;
  right: 0;
  width: 100%;
  z-index: 3;
  display: flex;
  margin-bottom: 10px;
  flex-direction: row;
`;

const PageContainer = styled.main`
  width: 100%;
  height: 100%;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
  /* &::-webkit-scrollbar {
    border-radius: 10px;
    height: 10px;
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background:#003876;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
  } */
`;

const SmallListItemContainer = styled.div`
  height: 35px;
  margin-left: 12px;
  width: 100%;
  padding: 5px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;

  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;

const TopBar = styled.section`
  position: absolute;
  z-index: 3;
  top: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${darkblue};
  color: #e1e1e1;
  height: 65px;
`;

const GridLogin = styled.div``;

const BoxLogin = styled.div`
  position: relative;
  margin: 0px 2.5px 20px 2.5px;
  width: 100%;
`;

const LabelBLogin = styled.label`
  position: absolute;
  pointer-events: none;
  left: 23px;
  top: 21px;
  transition: 0.2s;
  font-size: 25px;
  font-family: inherit;
`;
const CubeLogin = styled.div`
  margin: 0 auto;
  width: 500px;
  padding: 10px;
  margin-top: 9%;
`;

const LogoRepDom = styled.div`
  background-size: 45%;
  background-position: center;
  background-image: url(${Logo});
  background-repeat: no-repeat;
  margin-bottom: 50px;
  width: 500px;
  height: 200px;
  margin-top: -30px;
`;

const ErrorBox = styled.div`
  margin-left: 10px;
  color: red;
`;

const cDiv = styled.div`
  float: left;
  height: 28px;
  width: 21px;
  cursor: pointer;
`;

const EditContainer = styled.section`
  width: 100%;
  z-index: 2;
  display: flex;
  flex-direction: row;
  height: 100%;
`;

export {
  Container,
  PlayerBar,
  SideBar,
  EditContainer,
  Content,
  Navbar,
  PlayerContentContainer,
  PageContainer,
  PageContent,
  ListItemContainer,
  SmallListItemContainer,
  TopBar,
  GridLogin,
  BoxLogin,
  LabelBLogin,
  CubeLogin,
  LogoRepDom,
  ErrorBox,
  cDiv,
};
